import { isValidEmail } from '@/utils/isValidEmail/isValidEmail';
import isValidPhoneNumber from '@/utils/isValidPhoneNumber';
import { GetPatientDetailsSchema } from '@montugroup/pms-api-contracts';

export const schema = GetPatientDetailsSchema.shape.careInfo
  .unwrap()
  .shape.attributes.pick({
    gpName: true,
    gpClinic: true,
    gpPhone: true,
    gpEmail: true
  })
  .partial()
  .refine(
    (data) => {
      return (data.gpPhone || '').length === 0 || isValidPhoneNumber(data.gpPhone || '');
    },
    {
      message: 'Invalid phone number',
      path: ['gpPhone']
    }
  )
  .refine(
    (data) => {
      return (data.gpEmail || '').length === 0 || isValidEmail(data.gpEmail || '');
    },
    {
      message: 'Invalid email',
      path: ['gpEmail']
    }
  );
